import NextLink from 'next/link';
import { useTranslation } from 'react-i18next';
import styles from '../../HomepageSections.module.scss';
import { SectionHeading } from '../shared/SectionHeading';

const ingestionModes = ['zeroCode', 'batch', 'api', 'multiOrganisation'];

export const ScaleSection = () => {
  const { t } = useTranslation('landing');

  return (
    <section className={styles.scaleSection}>
      <div className={styles.scaleShell}>
        <SectionHeading
          eyebrow={t('homepage.scale.eyebrow')}
          title={t('homepage.scale.title')}
          description={t('homepage.scale.description')}
        />
        <div className={styles.scaleGrid}>
          <article className={styles.scaleCard}>
            <span className={styles.cardEyebrow}>{t('homepage.scale.highVolume.eyebrow')}</span>
            <div className={styles.scaleMetric}>
              <strong>{t('homepage.scale.highVolume.metric')}</strong>
              <span>{t('homepage.scale.highVolume.metricLabel')}</span>
            </div>
            <p>{t('homepage.scale.highVolume.description')}</p>
            <div className={styles.volumeChart} aria-hidden='true'>
              {[34, 48, 42, 64, 55, 76, 92, 70, 100].map((height, index) => (
                <i style={{ height: `${height}%` }} key={height + index} />
              ))}
            </div>
            <NextLink href='https://docs.eezi.io/docs/overview'>
              {t('homepage.scale.highVolume.link')} <span>→</span>
            </NextLink>
          </article>
          <article className={styles.scaleCard}>
            <span className={styles.cardEyebrow}>{t('homepage.scale.highComplexity.eyebrow')}</span>
            <div className={styles.scaleMetric}>
              <strong>2</strong>
              <span>{t('homepage.scale.highComplexity.metricLabel')}</span>
            </div>
            <p>{t('homepage.scale.highComplexity.description')}</p>
            <div className={styles.lineChart} aria-hidden='true'>
              {[92, 78, 84, 64, 71].map((width) => (
                <i style={{ width: `${width}%` }} key={width} />
              ))}
            </div>
            <NextLink href='https://docs.eezi.io/docs/overview'>
              {t('homepage.scale.highComplexity.link')} <span>→</span>
            </NextLink>
          </article>
        </div>
        <div className={styles.ingestionModes}>
          <strong>{t('homepage.scale.ingestion.title')}</strong>
          <div>
            {ingestionModes.map((mode) => (
              <NextLink href='https://docs.eezi.io/docs/overview' key={mode}>
                {t(`homepage.scale.ingestion.${mode}`)} <span>→</span>
              </NextLink>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
